import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { postNewDeposit } from '../services/depositService';

import ButtonComponent from "../components/ButtonComponent";
import '../assets/styles/new-deposit.css';
import '../assets/styles/modal-responsive.css';
import NavIconButton from "../components/NavIconButton";
import { faFileUpload, faHome } from "@fortawesome/free-solid-svg-icons";
import { routePath } from "../routes/routePath";
import { Modal } from 'react-bootstrap';
import { useAuth } from "../auth/AuthContext";
import OverlayLoadingSpinner from "../components/OverlayLoadingSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import errorMessages from "../constants/errorMessages";
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import ErrorPage from "../components/ErrorPage";

const NewDeposit = () => {
  const location = useLocation();
  const { userInfo } = useAuth();
const empId = userInfo?.empId;

const { depositForm, validationFields, itemVersionId } = location.state || {};
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState([]);  
  const [show, setShow] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false); 
  const [errorFileType, setErrorFileType] = useState(false); 
  const [errorFileSize, setErrorFileSize] = useState(false); 
  const [errors, setErrors] = useState({});
  const [itemClickLoading, setItemClickLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState({});
  const [successModal, setSuccessModal] = useState(false);
  const [depositResponse,setDepositResponse] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top on component mount
  }, []);

  const handleInputChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };
 
 
  const handleFileChange = (e, validationFieldVersionId) => {
    const file = e.target.files[0];
    const fileInput = e.target;
    if (file && file.type !== 'application/pdf') {
      // Reset the file input if it's not a PDF
      fileInput.value = null;
      setErrorFileType(true);
  
      // Clear the file name for the current field
      setSelectedFileName(prevState => ({
        ...prevState,
        [validationFieldVersionId]: null,
      }));
      return;
    }
  
    // Update the file state for the current field
    setUploadedFiles(prevState => [
      ...prevState.filter(f => f.validationFieldVersionId !== validationFieldVersionId),
      {
        validationFieldVersionId: validationFieldVersionId,
        file: file,
      }
    ]);
  
    // Set the selected file name for the current field
    setSelectedFileName(prevState => ({
      ...prevState,
      [validationFieldVersionId]: file.name,
    }));
  };

  const isValidDate = (dateValue) => {
    return dateValue instanceof Date && !isNaN(dateValue.getTime());
  };

const validateForm = () => {
  let formIsValid = true;
  let errors = {};
 const MAX_FILE_SIZE = 10 * 1024 * 1024;
 validationFields.forEach((field) => {
  const value = formValues[field.fieldName];

  // 🔹 Only validate required fields
  if (field.required) {
    if (field.fieldType === 'file') {
      const uploadedFile = uploadedFiles.find(
        (f) => f.validationFieldVersionId === field.validationFieldVersionId
      );
      if (!uploadedFile) {
        formIsValid = false;
        errors[field.fieldName] = "الملف مطلوب";
      } else if (uploadedFile.file && uploadedFile.file.size > MAX_FILE_SIZE) {
        const fileSizeInMB = (uploadedFile.file.size / (1024 * 1024)).toFixed(1);
        formIsValid = false;
        errors[field.fieldName] = `حجم الملف يجب ألا يتعدى 10 ميجابايت (الحالي: ${fileSizeInMB} MB)`;
      }
    } else if (field.fieldType === 'date') {
      if (!value || !isValidDate(value)) {
        formIsValid = false;
        errors[field.fieldName] = "التاريخ مطلوب";
      }
    } else if (!value || value.trim() === "") {
      formIsValid = false;
      errors[field.fieldName] = "هذا الحقل مطلوب";
    }
  }
});



  setErrors(errors);
  return formIsValid;
};

 const handleSubmit = async (e) => {
  e.preventDefault();
  setShow(false);
  setItemClickLoading(true);
  if (!validateForm()) { setShowErrorModal(true); setItemClickLoading(false); return; }

  try {
    // V2: single multipart POST — itemId, value pairs for non-file fields, loose file parts.
    const formData = new FormData();
    formData.append('itemId', depositForm.itemId);

    // Dates are composed at UTC midnight; the API expects date-only yyyy-MM-dd.
    const toYmd = (d) => {
      const y = d.getUTCFullYear();
      const m = String(d.getUTCMonth() + 1).padStart(2, '0');
      const day = String(d.getUTCDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    };

    let i = 0;
    validationFields.forEach((field) => {
      if (field.fieldType === 'file') return; // file-fields are sent as file parts below
      const raw = formValues[field.fieldName];
      const value = raw instanceof Date ? toYmd(raw) : (raw ?? "");
      formData.append(`validationFieldValues[${i}].vfvId`, field.validationFieldVersionId);
      formData.append(`validationFieldValues[${i}].value`, value);
      i++;
    });

    // Each file is paired with its file-field's vfvId (multiple files per field allowed).
    let j = 0;
    uploadedFiles.forEach((f) => {
      if (!f.file) return;
      formData.append(`files[${j}].vfvId`, f.validationFieldVersionId);
      formData.append(`files[${j}].file`, f.file);
      j++;
    });

    const res = await postNewDeposit(formData);
    setSuccessModal(true);
    setApiError(null);
    setDepositResponse(res);
  } catch (error) {
    setApiError(error.message);
    setShowErrorModal(true);
  } finally {
    setItemClickLoading(false);
  }
};
 
  // Handle show modal
  const handleShow = (e) => {
    e.preventDefault();
    // Perform client-side validation
    if (validateForm()) {
      setShow(true);   
    } else {
     setShowErrorModal(true);
    }
  };
  const handleRedirection=()=>{
    navigate('/');
  }
  const handleClose = () => setShow(false);
  const size = window.innerWidth < 600 ? '1.5rem' : '2rem';

  if (!depositForm) return <ErrorPage onRetry={()=>navigate('/')}/>
  return (
    <div className="deposit-form-container shadow-box col-12 d-flex flex-column align-items-center p-4 m-auto">
      {/* Header with Achievement Information */}
      <div className="deposit-form-header d-flex flex-column align-items-center mb-4">
        <img src={"https://rasedbankstorage.blob.core.windows.net/rasedbank-static-app-files/rased-bank-logo.png"} height="200" width="300" alt="Rased Logo" />
        <h5 className="mb-1">
          {depositForm.mainStandardSequence} {depositForm.mainStandardName}
        </h5>
        <h5 className="mb-1">
          {depositForm.mainStandardSequence} / {depositForm.subStandardSequence} {depositForm.subStandardName}
        </h5>
        <h5 className="mb-1">
          {depositForm.mainStandardSequence} / {depositForm.subStandardSequence} - {depositForm.itemSequence} {depositForm.itemName}
        </h5>
        <h5 className="mb-1">
          {"النقاط : " + depositForm.itemScore}
        </h5>
        <h5 className="mb-1">
          {depositForm.itemDescription}
        </h5>
      </div>
      {/* Navigation Button */}
      <NavIconButton
        icon={faHome}
        title="الرئيسية"
        hint="ايقونة الرئيسية"
        to={routePath.home}
        size={size}
      />  
 
      {/* Form for Depositing the Achievement */}
      <form className="deposit-form-info container col-12 mb-4">
      {validationFields.map((field, index) => (
  <div key={field.validationFieldVersionId} className="deposit-info-row shadow-box">
    <div className="d-flex flex-column align-items-start">
      <div>
      <span className="text-dark fw-bold">{field.fieldName}</span>
      {field.fieldType === 'file' ? <span className="mx-2 fw-bold text-dark badge bg-warning"> الشاهد </span> : null}
      </div>
      <p>{field.fieldDescription}</p>
    </div>

    {/* Handle file input */}
    {field.fieldType === 'file' ? (
      <div style={{ width: '60%', padding: '8px', borderRadius: '5px' }}>

        <input
          type="file"
          id={"inputFile" + field.validationFieldVersionId}
          accept=".pdf"
          style={{ display: 'none' }}
          onChange={(e) => handleFileChange(e, field.validationFieldVersionId)}  
        />
        <label htmlFor={"inputFile" + field.validationFieldVersionId} style={{ textAlign: 'start', cursor: 'pointer' }}>
          <FontAwesomeIcon icon={faFileUpload} size="xl" /> 
          {selectedFileName[field.validationFieldVersionId]
            ? selectedFileName[field.validationFieldVersionId]
            : "الرجاء رفع ملف pdf "}
        </label>
      </div>

    /* Handle date input with Flatpickr */
    )  : field.fieldType === 'date' ? (
 (() => {
  
    // read current value (expecting a Date or parsable date)
    const current =
      formValues[field.fieldName] ? new Date(formValues[field.fieldName]) : null;

    // use UTC so it matches your previous UTC-at-midnight storage
    const y = current ? current.getUTCFullYear() : "";
    const m = current ? current.getUTCMonth() + 1 : ""; // 1-12
    const d = current ? current.getUTCDate() : "";

    const years = Array.from({ length:15 }, (_, i) => new Date().getUTCFullYear() - i); // now..now-100
    const months = Array.from({ length: 12 }, (_, i) => i + 1); // 1..12

    const daysInMonth = (yy, mm) => {
      if (!yy || !mm) return 31;
      // Day 0 of next month gives last day of (yy, mm)
      return new Date(Date.UTC(Number(yy), Number(mm), 0)).getUTCDate();
    };

    const maxDay = daysInMonth(y || 1970, m || 1);
    const days = Array.from({ length: maxDay }, (_, i) => i + 1);

    const onPartChange = (part, value) => {
      const yy = part === "y" ? Number(value) || y : y || new Date().getUTCFullYear();
      const mm = part === "m" ? Number(value) || m : m || 1; // 1-12
      const ddRaw = part === "d" ? Number(value) || d : d || 1;

      const max = daysInMonth(yy, mm);
      const dd = Math.min(ddRaw, max);

      const composed = new Date(Date.UTC(Number(yy), Number(mm) - 1, Number(dd)));
      handleInputChange({
        target: { name: field.fieldName, value: composed },
      });
    };

    return (
      <div className="d-flex gap-2" style={{ width: "60%" }}>
        <select
          className="form-select"
          value={d}
          onChange={(e) => onPartChange("d", e.target.value)}
        >
          <option value="">اليوم</option>
          {days.map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>

        <select
          className="form-select"
          value={m}
          onChange={(e) => onPartChange("m", e.target.value)}
        >
          <option value="">الشهر</option>
          {months.map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>

        <select
          className="form-select"
          value={y}
          onChange={(e) => onPartChange("y", e.target.value)}
        >
          <option value="">السنة</option>
          {years.map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
      </div>
    );
  })()
 
    /* Handle other input types (text, etc.) */
    ) : (
      <input
        type={field.fieldType}
        name={field.fieldName}
        value={formValues[field.fieldName] || ""}
        onChange={handleInputChange}
        placeholder={field.fieldName}
        className="form-control"
      />
    )}

    {/* Display validation errors */}
    {errors[field.fieldName] && (
      <span className="alert alert-warning error-text">{errors[field.fieldName]}</span>
    )}
  </div>
))}
        {/* Display API Error */}
        {apiError && (
          <div className="error-message">
            <p>{apiError}</p>
          </div>
        )}
  
        {/* Submit Button */}
        <ButtonComponent text="ايداع" className="primary-bg" onClick={handleShow} />
      </form>
  

        {/* Modal for displaying  error file type */}
        <Modal 
        show={errorFileType}
         onHide={() => setErrorFileType(false)}
                centered 
  dialogClassName="custom-modal"
         >
        <Modal.Header >
          <Modal.Title className="ms-3">خطأ في نوعية الملف المرفوع</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            عذرا يجب رفع ملف pdf فقط
        </Modal.Body>
        <Modal.Footer>
          <ButtonComponent text="إغلاق" className="primary-bg" onClick={() => setErrorFileType(false)} />
        </Modal.Footer>
      </Modal>

      {/* Modal for displaying Success Submit */}
      <Modal 
      show={successModal}
       onHide={() => setSuccessModal(false)}
       centered 
  dialogClassName="custom-modal"
      >
        <Modal.Header>
          <Modal.Title className="ms-3">تم الايداع بنجاح .</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Modal.Title className="ms-3">الرقم المرجعي للايداع : {depositResponse.referenceNumber}.</Modal.Title>
        </Modal.Body>
        <Modal.Footer>
          <ButtonComponent text="إغلاق"  className=" primary-bg" onClick={() => handleRedirection()} />
        </Modal.Footer>
      </Modal>

      {/* Modal for displaying server-side validation errors */}
      <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)}
               centered 
  dialogClassName="custom-modal"
        >
        <Modal.Header closeButton>
          <Modal.Title className="ms-3">خطأ في الإيداع</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {apiError ? apiError : "يجب ملئ جميع الحقول"} {/* Display server-side error message */}
        </Modal.Body>
        <Modal.Footer>
          <ButtonComponent text="إغلاق" className="primary-bg" onClick={() => setShowErrorModal(false)} />
        </Modal.Footer>
      </Modal>

      {/* Modal for Confirmation */}
      <Modal show={show} onHide={handleClose}
             centered  
  dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="ms-3">تأكيد الإيداع</Modal.Title>
        </Modal.Header>
        <Modal.Body>هل أنت متأكد أنك تريد إيداع هذا الطلب؟</Modal.Body>
        <Modal.Footer>
          <ButtonComponent text="الغاء" className="danger-bg white-color" onClick={handleClose} />
          <ButtonComponent text="ايداع" className="primary-bg" onClick={handleSubmit} />
        </Modal.Footer>
      </Modal>
      {itemClickLoading && ( <OverlayLoadingSpinner/>)}
    </div>
  );
};

export default NewDeposit;
